module.exports = __webpack_public_path__ + "img/vector-square.2810a3e7.svg";